import { useContext } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'
import returnsServices from '@/returns/services/services'

const useRefundMethod = ({ setToastInfo }) => {
  const { rmaInfo, setRmaInfo } = useContext(RMAContext)

  const { fetchData: addRefundMethodToRma, loading: addingRefundMethod } = useFetch(
    returnsServices.addRefundMethodToRma,
    {
      doInitialRequest: false,
    }
  )

  const onChangeRefundMethod = async refundMethod => {
    try {
      setRmaInfo(rmaInfo => ({
        ...rmaInfo,
        orderInfo: {
          ...rmaInfo.orderInfo,
          refundType: refundMethod?.name,
        },
      }))

      const data = await addRefundMethodToRma({
        orderId: rmaInfo.orderInfo.id,
        returnId: rmaInfo.orderInfo.returnId,
        payload: {
          method: refundMethod.name,
        },
      })

      setRmaInfo(rmaInfo => ({
        ...rmaInfo,
        orderAmount: {
          ...rmaInfo.orderAmount,
          ...data?.summary,
        },
      }))
    } catch (err) {
      setToastInfo({ show: true, message: err?.errorMessage, type: 'error' })
    }
  }

  return {
    onChangeRefundMethod,
    addingRefundMethod,
  }
}

export default useRefundMethod
